import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { map, keys, pickBy, equals } from 'ramda';
import Translate from 'react-translate-component';
import { Dropdown, Menu } from 'antd';
import cx from 'classnames';

import { setFilter } from 'helpers/filterHelpers';
import CustomIcon from 'components/common/CustomIcon';

const defaultStatus = 'all';

export default class DropdownStatusFilter extends Component {
    static propTypes = {
        filters: PropTypes.object.isRequired,
        translation: PropTypes.string.isRequired,
        defaultFilters: PropTypes.object.isRequired,
        onFiltersChange: PropTypes.func.isRequired
    };

    changeFilter = (status) => {
        const { onFiltersChange, defaultFilters } = this.props;

        const filters = setFilter(status, defaultFilters);
        onFiltersChange(filters);
    }

    getFiltersMenu = (selected) => {
        const { defaultFilters, translation } = this.props;

        return (
            <Menu selectedKeys={selected}>
                <Menu.Item className="text-right" disabled>
                    <Translate content='filter' component='span' />
                </Menu.Item>
                <Menu.Item key='all'>
                    <Translate content='filterStatus.all'
                               component='a'
                               onClick={() => this.changeFilter(defaultStatus)} />
                </Menu.Item>
                { map((status) => (
                    <Menu.Item key={status}>
                        <Translate content={translation + status}
                                   component='a'
                                   onClick={() => this.changeFilter(status)} />
                    </Menu.Item>
                ), keys(defaultFilters))}
            </Menu>
        );
    }

    render() {
        const { defaultFilters, filters } = this.props;

        let selected = ['all'];
        if (!equals(defaultFilters, filters)) {
            selected = keys(pickBy(Boolean, filters));
        }

        return (
            <Dropdown trigger={['click']} placement='bottomRight' overlay={this.getFiltersMenu(selected)}>
                <a>
                    <CustomIcon type="filter" className={cx({'sort-icon-not-default': selected[0] !== defaultStatus})} />
                </a>
            </Dropdown>
        );
    }
}
